<template>
  <div class="p-field-checkbox" :class="classes">
    <Checkbox v-model="text.value" :binary="true" @change="onChange" :id="label" :disabled="disabled"/>
    <label v-if="label" :for="label">{{ label }}</label>
  </div>
  <small v-if="!!errorMessage" :class="{'p-error': true}">
    {{ errorMessage }}
  </small>
</template>
<script>
import Checkbox from "primevue/checkbox/sfc";
import {useField} from "vee-validate/dist/vee-validate.min.js";
import {reactive} from "@vue/reactivity";
export default {
  components: {
    Checkbox,
  },
  setup(props, {emit}) {
    const {value, errorMessage} = useField(props.name, undefined, {
      initialValue: props.modelValue,
    });

    const text = reactive({
      value: value,
    });

    const onChange = (value1) => {
      emit("update:modelValue", value);
      if (props.changeAction != undefined) props.changeAction(text.value);
    };

    return {
      onChange,
      value,
      text,
      errorMessage,
    };
  },
  emits: ["update:modelValue"],

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    classes: {
      Type: Object,
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
      default: "",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    changeAction: Function,
  },
  watch: {
    modelValue: {
      handler(newValue, oldValue) {
        this.text.value = newValue;
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.p-error {
  color: $error !important;
  margin-top: 2px;
}

.p-checkbox {
  width: 20px !important;
  height: 20px !important;
}

.p-checkbox {
  box-shadow: none !important;
}

.p-checkbox .p-checkbox-box {
  border: 1px solid $grey !important;
  border-radius: 5px !important;
  width: 16px !important;
  height: 16px !important;
  min-width: 16px !important;

  &.p-highlight {
    border-color: $tertiary-color !important;
  }
}
.p-checkbox .p-checkbox-box.p-highlight .p-checkbox-icon.pi-check:before {
  top: 9px !important;
  left: 3px !important;
}
.p-input-filled .p-checkbox .p-checkbox-box.p-highlight {
  background-color: $tertiary-color !important;
}

.p-field-checkbox {
  label {
    @include f-button;
    //font-size: 15px;
  }
}
</style>
